export const CRM_SALON_EMAILS = [
  'e.marquet@weedoit.fr',
  'k.ghalem@weedoit.fr',
  'a.gorani@weedoit.fr',
  's.boukbir@weedoit.fr'
]

export const PIPELINES = [
  'Nouveau',
  'Contacté',
  'Qualifié',
  'Devis envoyé',
  'Négociation',
  'Signé',
  'Perdu'
]

export const PASSAGES = [
  { id: 'visite', label: 'Simple visite', hint: 'Passage stand, peu de temps' },
  { id: 'echange', label: 'Échange court', hint: 'Quelques minutes, points notés' },
  { id: 'rdv', label: 'Souhaite un RDV', hint: 'On calera un créneau plus posé' },
  { id: 'proposition', label: 'Souhaite une proposition', hint: 'À envoyer après le salon' }
]

export const PARTNERS = [
  { id: 'courtier', label: 'Courtier' },
  { id: 'agent', label: 'Agent' },
  { id: 'mutuelle', label: 'Mutuelle' },
  { id: 'assureur', label: 'Assureur' },
  { id: 'autre', label: 'Autre' }
]

export const WORK_MODES = [
  { id: 'agence', label: 'Agence' },
  { id: 'terrain', label: 'Terrain' },
  { id: 'vad', label: 'VAD' }
]

export const SIZES = [
  { id: 'solo', label: 'Solo' },
  { id: '2-5', label: '2 à 5' },
  { id: '6-15', label: '6 à 15' },
  { id: '16+', label: '16 et +' }
]

export const VAD_COUNTRIES = [
  'Maroc', 'Tunisie', 'Algérie', 'Île Maurice', 'Madagascar', 'Sénégal', 'Portugal', 'France', 'Autre'
]

export const PRODUCTS = [
  { id: 'sante', label: 'Santé individuelle' },
  { id: 'animaux', label: 'Animaux' },
  { id: 'auto', label: 'Auto' },
  { id: 'habitation', label: 'Habitation' },
  { id: 'emprunteur', label: 'Emprunteur' },
  { id: 'tns', label: 'TNS Santé' }
]

export const OFFERS = [
  { id: 'entrant', label: 'Appel entrant 10' },
  { id: 'comparateur_mg', label: 'Comparateur MonGustave' },
  { id: 'comparateur_gaston', label: 'Comparateur MonGaston' },
  { id: 'coreg', label: 'Coreg' },
  { id: 'cosponso', label: 'Co-sponso' },
  { id: 'relation', label: 'Mise en relation' }
]

export const BUYS = [
  { id: 'non', label: 'N’achète pas' },
  { id: 'interne', label: 'Campagnes internes' },
  { id: 'presta', label: 'Via un prestataire' }
]

export const BUDGETS = [
  { id: '<3k', label: '< 3 k€' },
  { id: '3-5k', label: '3 – 5 k€' },
  { id: '5-10k', label: '5 – 10 k€' },
  { id: '10k+', label: '> 10 k€' }
]

export const LEAD_TYPES = [
  { id: 'exclusif', label: 'Exclusif' },
  { id: 'coreg', label: 'Coreg' },
  { id: 'cosponso', label: 'Co-sponso' },
  { id: 'trio', label: 'Trio' },
  { id: 'entrant', label: 'Appel entrant 10' },
  { id: 'relation', label: 'Mise en relation' }
]

export const PRICES = [
  { id: '2', label: '2 €' },
  { id: '5', label: '5 €' },
  { id: '8', label: '8 – 12 €' },
  { id: '15', label: '15 € +' },
  { id: '?', label: 'Ne sait pas' }
]

export const CONVS = [
  { id: '1', label: '1 %' },
  { id: '3', label: '3 %' },
  { id: '5', label: '5 %' },
  { id: '8', label: '8 % +' },
  { id: '?', label: 'Ne sait pas' }
]

export const CRMS = [
  { id: 'aucun', label: 'Aucun' },
  { id: 'oggodata', label: 'Oggo data' },
  { id: 'modulr', label: 'Modulr' },
  { id: 'ecilia', label: 'Ecilia' },
  { id: 'duplix', label: 'Duplix' },
  { id: 'assur3d', label: 'Assur 3D' },
  { id: 'hubspot', label: 'Hubspot' },
  { id: 'courtigo', label: 'Courtigo' },
  { id: 'assurcrm', label: 'AssurCRM' },
  { id: 'salesforce', label: 'Salesforce' },
  { id: 'sellsy', label: 'Sellsy' },
  { id: 'phingoo', label: 'Phingoo' },
  { id: 'autre', label: 'Autre' }
]

export const MARKET = {
  exclusif: { price: '8 – 15 €', conv: '5 – 8 %' },
  coreg: { price: '5 – 8 €', conv: '2 – 4 %' },
  cosponso: { price: '5 – 8 €', conv: '2 – 4 %' },
  trio: { price: '2 – 5 €', conv: '1 – 3 %' },
  entrant: { price: '10 €', conv: '5 – 10 %' },
  relation: { price: '15 € +', conv: '8 % +' }
}

// Parts affichées : 10, 15, 20 et 25 dispersés. Le tirage (90/4/4/2) reste côté API.
export const WHEEL_SLICES = [10, 15, 10, 20, 10, 25, 10, 15, 10, 20]

export const WHEEL_COLORS = ['#1b2a4a', '#ff6500', '#243556', '#ff6500', '#1b2a4a', '#1f7a4d']

export function sliceIndexForPrize(prize) {
  const hits = []
  for (let i = 0; i < WHEEL_SLICES.length; i++) {
    if (WHEEL_SLICES[i] === prize) hits.push(i)
  }
  if (!hits.length) return -1
  return hits[Math.floor(Math.random() * hits.length)]
}

export function wheelTargetRotation(prize, currentRot, sliceIndex) {
  const n = WHEEL_SLICES.length
  const sweep = 360 / n
  const idx = sliceIndex == null ? sliceIndexForPrize(prize) : sliceIndex
  const center = idx * sweep + sweep / 2
  const jitter = (Math.random() - 0.5) * (sweep * 0.4)
  // Pointeur en haut : amener le centre de la tranche sous le pointeur
  const base = ((currentRot % 360) + 360) % 360
  const targetMod = (360 - center + jitter + 360) % 360
  let delta = targetMod - base
  if (delta < 0) delta += 360
  return currentRot + 360 * 6 + delta
}

export function toWhatsAppNumber(raw) {
  if (!raw) return null
  let n = String(raw).replace(/\D/g, '')
  if (!n) return null
  if (n.startsWith('00')) n = n.slice(2)
  if (n.startsWith('0') && n.length === 10) n = `33${n.slice(1)}`
  else if (n.length === 9) n = `33${n}`
  if (n.length < 10 || n.length > 15) return null
  return n
}

export function prizeWhatsAppText(prenom, prize) {
  const first = (prenom || '').split(' ')[0] || ''
  return `Bravo${first ? ` ${first}` : ''} !

Vous venez de gagner ${prize} % de remise sur votre première commande Weedoit, aux Journées du Courtage.

Offre salon valable 30 jours. Je vous l’envoie ici pour qu’on reste en contact.

Formation : https://weedoit.fr/formation/webinar-reglementaire

Weedoit · Salons`
}

export function waHref(tel, text) {
  const n = toWhatsAppNumber(tel)
  if (!n) return null
  return `https://wa.me/${n}?text=${encodeURIComponent(text)}`
}

export function mailtoPrize(email, prenom, prize) {
  const first = (prenom || '').split(' ')[0] || ''
  const subject = `— un plaisir de vous croiser`
  const body = `Bonjour ${first},

Ravi de notre échange à la Journée du Courtage.

Vous repartez avec ${prize} % de remise sur votre première commande Weedoit. Offre valable 30 jours.

Weedoit · Salons`
  return `mailto:${email || ''}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export function computeCopilot(form) {
  const expertCrm = ['oggodata', 'modulr', 'ecilia', 'duplix', 'assur3d', 'hubspot', 'courtigo', 'assurcrm', 'salesforce', 'sellsy', 'phingoo']
  let score = 2
  let verdict = 'naif'
  if (form.buys_leads === 'presta') score += 1
  if (form.budget_band === '5-10k' || form.budget_band === '10k+') score += 1
  if (expertCrm.indexOf(form.crm_key) >= 0) {
    score += 2
    verdict = 'expert'
  }
  const price = form.price_band === '?' ? null : Number(form.price_band)
  const conv = form.conv_band === '?' ? null : Number(form.conv_band)
  if (price != null && price <= 2 && conv != null && conv >= 5) {
    verdict = 'charlot'
    score = Math.min(score, 2)
  } else if (verdict !== 'expert' && form.buys_leads === 'presta') {
    verdict = 'serieux'
  }
  score = Math.max(1, Math.min(5, score))
  return { score, verdict }
}

export function displayName(p) {
  if (!p) return '—'
  const n = [p.prenom, p.nom].filter(Boolean).join(' ').trim()
  return n || p.societe || p.email || 'Contact'
}

export const SOURCE_LABELS = {
  monday: 'Monday',
  webinar: 'Webinaire',
  client: 'Client',
  heomi: 'Héomi',
  edouard: 'Édouard',
  karim: 'Karim'
}

const ACCOUNT_SOURCE_TAGS = [
  { tag: 'edouard', actors: ['e.marquet'], charges: ['edouard', 'marquet'] },
  { tag: 'karim', actors: ['k.ghalem'], charges: ['karim', 'ghalem'] }
]

export function sourceFlags(raw) {
  if (!raw) return []
  return String(raw).split(',').map((s) => s.trim()).filter(Boolean)
}

export function sourceLabel(src) {
  return SOURCE_LABELS[src] || src
}

/** Flags persistés + tag Édouard / Karim si le contact a été traité par leur compte. */
export function displaySourceFlags(contact) {
  const flags = sourceFlags(contact && contact.sources)
  if (!contact) return flags
  const actors = [
    contact.created_by,
    contact.updated_by
  ]
  ;['visits', 'rdvs', 'prizes'].forEach((key) => {
    ;(contact[key] || []).forEach((row) => {
      if (row && row.created_by) actors.push(row.created_by)
    })
  })
  const actorHay = actors.filter(Boolean).join(' ').toLowerCase()
  const chargeHay = String(contact.charge || '').toLowerCase()
  ACCOUNT_SOURCE_TAGS.forEach(({ tag, actors: needles, charges }) => {
    if (flags.indexOf(tag) >= 0) return
    const byAccount = needles.some((n) => actorHay.indexOf(n) >= 0)
    const byCharge = charges.some((n) => chargeHay.indexOf(n) >= 0)
    if (byAccount || byCharge) flags.push(tag)
  })
  return flags
}

export function parseJsonField(v, fallback) {
  if (v == null || v === '') return fallback
  if (typeof v === 'object') return v
  try {
    return JSON.parse(v)
  } catch (e) {
    return fallback
  }
}

/** Modes de vente (CSV) — rétrocompat si une seule valeur. */
export function parseWorkModes(raw) {
  if (!raw) return []
  return String(raw).split(',').map((s) => s.trim()).filter(Boolean)
}

export function serializeWorkModes(arr) {
  return (arr || []).filter(Boolean).join(',')
}

/**
 * Chemin de retour depuis query.from.
 * Sécurité : uniquement les routes /crm-salon*.
 */
export function salonReturnTo(route, fallback) {
  const fb = fallback !== undefined ? fallback : '/crm-salon'
  const raw = route && route.query && route.query.from
  if (!raw || typeof raw !== 'string') return fb
  let decoded = raw
  try {
    decoded = decodeURIComponent(raw)
  } catch (e) { /* keep raw */ }
  if (decoded.indexOf('/crm-salon') !== 0) return fb
  return decoded
}

/** Libellé court pour le bouton retour (Carnet, Pipeline…). */
export function salonReturnLabel(fromPath) {
  const p = String(fromPath || '')
  if (p.indexOf('/crm-salon/carnet') === 0) return '← Carnet'
  if (p.indexOf('/crm-salon/pipeline') === 0) return '← Pipeline'
  if (p.indexOf('/crm-salon/journee') === 0) return '← Journée'
  if (p.indexOf('/crm-salon/a-faire') === 0) return '← À faire'
  if (p.indexOf('/crm-salon/visite') === 0) return '← Visite'
  if (p.indexOf('/crm-salon/qualifier') === 0) return '← Qualification'
  if (p === '/crm-salon' || p.indexOf('/crm-salon?') === 0) return '← Accueil'
  return '← Retour'
}

/**
 * Ajoute from (fullPath) à une destination Vue Router.
 * @param {string|object} to
 * @param {string} fromFullPath
 */
export function withFrom(to, fromFullPath) {
  const from = fromFullPath || ''
  if (typeof to === 'string') {
    return from ? { path: to, query: { from } } : { path: to }
  }
  const query = Object.assign({}, (to && to.query) || {})
  if (from) query.from = from
  else delete query.from
  return Object.assign({}, to, { query })
}

/** Prefixe e-mail du compte connecté (ex. e.marquet). */
export function currentSalonAccountLabel() {
  try {
    const u = JSON.parse(localStorage.getItem('utilisateur') || '{}')
    const email = String(u.email || '').trim()
    if (!email) return ''
    const at = email.indexOf('@')
    return at > 0 ? email.slice(0, at) : email
  } catch (e) {
    return ''
  }
}

const PARIS_TZ = 'Europe/Paris'

/**
 * Horodatage d'activité : privilégie updated_at (qualification / MAJ),
 * puis at / visited_at / created_at.
 */
export function activityTimestamp(row) {
  if (!row) return null
  return row.updated_at || row.at || row.visited_at || row.created_at || null
}

function pad2(n) {
  return n < 10 ? '0' + n : String(n)
}

/** Découpe une chaîne date API (UTC naive, ISO, etc.). */
function matchDateParts(raw) {
  const s = String(raw || '').trim()
  if (!s) return null
  const m = s.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?)?/
  )
  if (!m) return null
  return {
    y: Number(m[1]),
    mo: Number(m[2]),
    d: Number(m[3]),
    h: m[4] != null ? Number(m[4]) : 12,
    mi: m[5] != null ? Number(m[5]) : 0,
    s: Number(m[6] || 0),
    offset: m[7] || null,
    hasTime: m[4] != null
  }
}

/**
 * Instant (ms) depuis une date API AUTH / RDS.
 * RDS = UTC (NOW() = UTC_TIMESTAMP). Les DATETIME sans offset
 * sont donc lus comme UTC, puis affichés en Europe/Paris.
 */
export function toParisInstant(raw) {
  const parts = matchDateParts(raw)
  if (!parts) {
    const d = new Date(raw)
    return isNaN(d.getTime()) ? null : d.getTime()
  }
  if (parts.offset) {
    const iso =
      pad2(parts.y) + '-' + pad2(parts.mo) + '-' + pad2(parts.d) +
      'T' + pad2(parts.h) + ':' + pad2(parts.mi) + ':' + pad2(parts.s) +
      (parts.offset === 'Z' ? 'Z' : parts.offset)
    const t = Date.parse(iso)
    return isNaN(t) ? null : t
  }
  // Naive DATETIME RDS / Laravel → UTC
  return Date.UTC(parts.y, parts.mo - 1, parts.d, parts.h, parts.mi, parts.s)
}

function parisPartsFromMs(ms) {
  if (ms == null || isNaN(ms)) return null
  const dtf = new Intl.DateTimeFormat('en-GB', {
    timeZone: PARIS_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
  const bag = {}
  dtf.formatToParts(new Date(ms)).forEach((p) => {
    if (p.type !== 'literal') bag[p.type] = p.value
  })
  let hour = Number(bag.hour)
  if (hour === 24) hour = 0
  return {
    year: Number(bag.year),
    month: Number(bag.month),
    day: Number(bag.day),
    hour,
    minute: Number(bag.minute),
    second: Number(bag.second)
  }
}

/** Heure 0–23 à Paris pour l'affluence. */
export function parisHour(raw) {
  const ms = toParisInstant(raw)
  const p = parisPartsFromMs(ms)
  return p ? p.hour : null
}

export function formatParisDateTime(raw) {
  const ms = toParisInstant(raw)
  const p = parisPartsFromMs(ms)
  if (!p) return raw ? String(raw) : '—'
  return (
    pad2(p.day) + '/' + pad2(p.month) + '/' + p.year +
    ' ' + pad2(p.hour) + ':' + pad2(p.minute)
  )
}

/**
 * Ajoute un commentaire horodaté (Paris) + compte à note_interne,
 * sans écraser l'historique.
 * @param {string} [kind] - 'action' → préfixe Action, sinon commentaire simple
 */
export function appendNoteInterne(existing, text, account, kind) {
  const body = String(text || '').trim()
  if (!body) return existing || ''
  const stamp = formatParisDateTime(new Date().toISOString())
  const who = String(account || '').trim()
  const tag = kind === 'action' ? 'Action' : null
  const line = [stamp, who, tag].filter(Boolean).join(' · ') + ' : ' + body
  const prev = String(existing || '').trim()
  return prev ? prev + '\n' + line : line
}

/** Date seule YYYY-MM-DD (salon, jour RDV) — pas de conversion UTC. */
export function formatCalendarDate(raw) {
  if (raw == null || raw === '') return '—'
  const s = String(raw).trim()
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) return m[3] + '/' + m[2] + '/' + m[1]
  return formatSalonDate(s)
}

/**
 * Affichage date CRM :
 * - déjà fr (jj/mm/aaaa, mm/aaaa) → tel quel
 * - YYYY-MM-DD → calendrier (pas UTC)
 * - DATETIME API → UTC → Europe/Paris
 */
export function formatSalonDate(raw) {
  if (raw == null || raw === '') return '—'
  const s = String(raw).trim()
  if (/^\d{1,2}\/\d{1,2}\/\d{2,4}$/.test(s)) return s
  if (/^\d{1,2}\/\d{4}$/.test(s)) return s
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    return m[3] + '/' + m[2] + '/' + m[1]
  }
  const parts = matchDateParts(s)
  if (parts && !parts.hasTime) {
    return pad2(parts.d) + '/' + pad2(parts.mo) + '/' + parts.y
  }
  const ms = toParisInstant(s)
  const p = parisPartsFromMs(ms)
  if (!p) return s
  return pad2(p.day) + '/' + pad2(p.month) + '/' + p.year
}

export function formatParisDate(raw) {
  return formatSalonDate(raw)
}

export function formatParisTime(raw) {
  const ms = toParisInstant(raw)
  const p = parisPartsFromMs(ms)
  if (!p) return ''
  return pad2(p.hour) + ':' + pad2(p.minute)
}

/** Chip jour salon : "16 sept" depuis YYYY-MM-DD. */
export function formatDayChip(iso) {
  if (!iso) return ''
  const MONTHS_SHORT = ['jan', 'fév', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc']
  const p = String(iso).split('-')
  if (p.length < 3) return iso
  const m = MONTHS_SHORT[Number(p[1]) - 1] || p[1]
  return Number(p[2]) + ' ' + m
}

/** Plage de dates salon affichée. */
export function formatDateRange(start, end) {
  if (!start && !end) return '—'
  if (!end || start === end) return formatCalendarDate(start || end)
  return formatCalendarDate(start) + ' → ' + formatCalendarDate(end)
}

/** Date du jour à Paris (YYYY-MM-DD), pas UTC. */
export function parisTodayIso() {
  const p = parisPartsFromMs(Date.now())
  if (!p) return new Date().toISOString().slice(0, 10)
  return p.year + '-' + pad2(p.month) + '-' + pad2(p.day)
}

/**
 * Affluence horaire (Paris) : 1 contact = 1 créneau (dernière activité / update).
 * Évite de compter visite + qualification + remise séparément.
 */
export function buildParisAffluence(rows) {
  const latestByProspect = {}
  ;(rows || []).forEach((r) => {
    const pid = String(r.prospect_id || r.id || '')
    if (!pid) return
    const stamp = activityTimestamp(r)
    const ms = toParisInstant(stamp)
    if (ms == null) return
    const prev = latestByProspect[pid]
    if (!prev || ms > prev.ms) {
      latestByProspect[pid] = { ms, stamp }
    }
  })
  const byHour = {}
  Object.keys(latestByProspect).forEach((pid) => {
    const h = parisHour(latestByProspect[pid].stamp)
    if (h == null) return
    byHour[h] = (byHour[h] || 0) + 1
  })
  return Object.keys(byHour)
    .map(Number)
    .sort((a, b) => a - b)
    .map((hour) => ({ hour, count: byHour[hour] }))
}

